import { Icon } from '@octano/global-ui';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Col, Row, UncontrolledTooltip } from 'reactstrap';

import { CreditsSummaryData } from '../../../types/tuitionContinuityV2';

const prefix = 'tuitionContinuityV2.creditsSummary';

interface CreditsSummaryProps {
  summary: CreditsSummaryData;
}

interface CreditCard {
  label: string;
  value: number;
  tooltip: string;
  id: string;
}

export default function CreditsSummary({ summary }: CreditsSummaryProps) {
  const { t } = useTranslation();

  const cards = useMemo<CreditCard[]>(
    () => [
      {
        label: t(`${prefix}.recommended`),
        value: summary.creditsRecommended,
        tooltip: t(`${prefix}.tooltipRecommended`),
        id: 'credits-recommended',
      },
      {
        label: t(`${prefix}.toEnroll`),
        value: summary.creditsToEnroll,
        tooltip: t(`${prefix}.tooltipToEnroll`),
        id: 'credits-to-enroll',
      },
      {
        label: t(`${prefix}.frozen`),
        value: summary.creditsFrozen,
        tooltip: t(`${prefix}.tooltipFrozen`),
        id: 'credits-frozen',
      },
      {
        label: t(`${prefix}.toPay`),
        value: summary.creditsToPay,
        tooltip: t(`${prefix}.tooltipToPay`),
        id: 'credits-to-pay',
      },
    ],
    [summary, t],
  );

  return (
    <div className="mt-4">
      <p className="fs-20 text-uppercase text-primary fw-700">
        {t(`${prefix}.title`)}
      </p>
      <p className="fs-16 fw-300 mb-3">{t(`${prefix}.description`)}</p>
      <Row>
        {cards.map((card) => (
          <Col key={card.id} xs={6} md={3} className="mb-3">
            <div
              className="d-flex flex-column align-items-center p-3 rounded"
              style={{ background: '#f7f7f7' }}
            >
              <div
                className="d-flex align-items-center mb-2"
                style={{ gap: 4 }}
              >
                <span className="fs-14 text-muted me-1">{card.label}</span>
                <span id={card.id}>
                  <Icon name="information" size="14px" color="secondary" />
                </span>
                <UncontrolledTooltip target={card.id}>
                  {card.tooltip}
                </UncontrolledTooltip>
              </div>
              <span className="fs-22 fw-700 text-primary">{card.value}</span>
            </div>
          </Col>
        ))}
      </Row>
    </div>
  );
}
